<h2 mat-dialog-title>{{ 'SelectWorkLocations' | translate: {Default: "Select Work Locations"} }}</h2>

<mat-dialog-content>
    <div *ngIf="selectedWorkLocations.length > 0" class="selected-goal page-description-section">
        <h6>{{ 'SelectedWorkLocations' | translate: {Default: "Selected Work Locations"} }}: 
            <span *ngFor="let workLocation of selectedWorkLocations; index as i">
                <span *ngIf="i > 0">, </span>{{workLocation.name}}
            </span>
        </h6>
    </div>

    <app-data-grid-comp
        [columns]="columns"
        [gridDataResult]="gridDataResult"
        [isLoading]="isLoading"
        [pageSize]="pageSize"
        [skip]="skip"
        category=""
        [rowSelectionSettings]="selectionSettings"
        [selectedRowsButtonSettings]="{
            show: false
        }"
        [selectedItems]="selectedWorkLocationsIds"
        clickableRows="true"
        hideActionButtons="true"
        searchable="true"
        [filterCategories]="columns"
        [clearSelectedItems]="clearSelectedItems"
        [filterToggleDetails]="filterToggleDetails"
        [sortable]="{
            mode: 'multiple'
        }"
        [sortableColumns]="sortableColumns"
        (emitGridStateChangeEvent)="gridStateChange($event)"
        (emitSelectedRows)="selectedRowsChanged($event)"
    ></app-data-grid-comp>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="selectedWorkLocations.length === 0">{{ 'Save' | translate: {Default: "Save"} }}</button>
</mat-dialog-actions>